const highChartThailandMap = [
  ['th-ct', 0], // จันทบุรี
  ['th-4255', 0], //
  ['th-pg', 0], // พังงา
  ['th-st', 0], // สุราษฎร์ธานี
  ['th-kr', 0], // กระบี่
  ['th-sa', 0], // สตูล
  ['th-tg', 0], // ตรัง
  ['th-tt', 0], // ตราด
  ['th-pl', 0], // พัทลุง
  ['th-ps', 0], // พิษณุุโลก
  ['th-kp', 0], // กำแพงเพชร
  ['th-pc', 0], // พิจิตร
  ['th-sh', 0], // สุพรรณบุรี
  ['th-at', 0], // อ่างทอง
  ['th-lb', 0], // ลพบุรี
  ['th-pa', 0], // อยุธยา
  ['th-np', 0], // นครปฐม
  ['th-sb', 0], // สิงห์บุรี
  ['th-cn', 0], // ชัยนาถ
  ['th-bm', 0], // กรุงเทพ
  ['th-pt', 0], // ปทุมธานี
  ['th-no', 0], // นนทบุรี
  ['th-sp', 0], // สมุทรปราการ
  ['th-ss', 0], // สมุทราสาคร
  ['th-sm', 0], // สมุทรสงคราม
  ['th-pe', 0], // เพชรบุรี
  ['th-cc', 0], // ฉะเชิงเทรา
  ['th-nn', 0], // นครนายก
  ['th-cb', 0], // ชลบุรี
  ['th-br', 0], // บุรีย์รัม
  ['th-kk', 0], // ขอนแก่น
  ['th-ph', 0], // เพชรบูรณ์
  ['th-kl', 0], // กาฬสิน
  ['th-sr', 0], // สระบุรี
  ['th-nr', 0], // นครราชศรีมา
  ['th-si', 0], // ศรีสะเกศ
  ['th-re', 0], // ร้อยเอ็ด
  ['th-le', 0], // เลย
  ['th-nk', 0], // หนองคาย
  ['th-ac', 0], // อำนาจเจริญ
  ['th-md', 0], // มุกดาหาร
  ['th-sn', 0], // สกลนคร
  ['th-nw', 0], // นราธิวาส
  ['th-pi', 0], // ปัตตานี
  ['th-rn', 0], // ระนอง
  ['th-nt', 0], // นครศรีธรรมราช
  ['th-sg', 0], // สงขลา
  ['th-pr', 0], // แพร่
  ['th-py', 0], // พะเยา
  ['th-so', 0], // สุโขทัย
  ['th-ud', 0], // อุตรดิตถ์
  ['th-kn', 0], // กาญจนบุรี
  ['th-tk', 0], // ตาก
  ['th-ut', 0], // อุทัยธานี
  ['th-ns', 0], // นครสวรรค์
  ['th-pk', 0], // ประจวบคีรีขันธ์
  ['th-ur', 0], // อุบลราชธานี
  ['th-sk', 0], // สระแก้ว
  ['th-ry', 0], // ระยอง
  ['th-cy', 0], // ชัยภูมิ
  ['th-su', 0], // สุรินทร์
  ['th-nf', 0], // นครพนม
  ['th-bk', 0], // บึงกาฬ
  ['th-mh', 0], // แม่ฮ่องสอน
  ['th-pu', 0], // ภูเก็ต
  ['th-cp', 0], // ชุมพร
  ['th-yl', 0], // ยะลา
  ['th-cr', 0], // เชียงราย
  ['th-cm', 0], // เชียงใหม่
  ['th-ln', 0], // ลำพูน
  ['th-na', 0], // น่าน
  ['th-lg', 0], // ลำปาง
  ['th-pb', 0], // ปราจีนบุรี
  ['th-rt', 0], // ราชบุรี
  ['th-ys', 0], // ยโสธร
  ['th-ms', 0], // มหาสารคาม
  ['th-un', 0], // อุดรธานี
  ['th-nb', 0], // หนองบัวลําภู
];

export default function useHighChartMap() {
  function getProperty(value: string | number): { shortForm: string | number; region: string } {
    /* eslint-disable */
    // CENTRAL
    if (value === 1 || value === 'กรุงเทพมหานคร') return { shortForm: 'bm', region: 'CENTRAL' };
    else if (value === 2 || value === 'สมุทรปราการ') return { shortForm: 'sp', region: 'CENTRAL' };
    else if (value === 3 || value === 'นนทบุรี') return { shortForm: 'no', region: 'CENTRAL' };
    else if (value === 4 || value === 'ปทุมธานี') return { shortForm: 'pt', region: 'CENTRAL' };
    else if (value === 5 || value === 'พระนครศรีอยุธยา') return { shortForm: 'pa', region: 'CENTRAL' };
    else if (value === 6 || value === 'อ่างทอง') return { shortForm: 'at', region: 'CENTRAL' };
    else if (value === 7 || value === 'ลพบุรี') return { shortForm: 'lb', region: 'CENTRAL' };
    else if (value === 8 || value === 'สิงห์บุรี') return { shortForm: 'sb', region: 'CENTRAL' };
    else if (value === 9 || value === 'ชัยนาท') return { shortForm: 'cn', region: 'CENTRAL' };
    else if (value === 10 || value === 'สระบุรี') return { shortForm: 'sr', region: 'CENTRAL' };
    else if (value === 17 || value === 'นครนายก') return { shortForm: 'nn', region: 'CENTRAL' };
    // EASTERN
    else if (value === 11 || value === 'ชลบุรี') return { shortForm: 'cb', region: 'EASTERN' };
    else if (value === 12 || value === 'ระยอง') return { shortForm: 'ry', region: 'EASTERN' };
    else if (value === 13 || value === 'จันทบุรี') return { shortForm: 'ct', region: 'EASTERN' };
    else if (value === 14 || value === 'ตราด') return { shortForm: 'tt', region: 'EASTERN' };
    else if (value === 15 || value === 'ฉะเชิงเทรา') return { shortForm: 'cc', region: 'EASTERN' };
    else if (value === 16 || value === 'ปราจีนบุรี') return { shortForm: 'pb', region: 'EASTERN' };
    else if (value === 18 || value === 'สระแก้ว') return { shortForm: 'sk', region: 'EASTERN' };
    // NORTHEASTERN
    else if (value === 19 || value === 'นครราชสีมา') return { shortForm: 'nr', region: 'NORTHEASTERN' };
    else if (value === 20 || value === 'บุรีรัมย์') return { shortForm: 'br', region: 'NORTHEASTERN' };
    else if (value === 21 || value === 'สุรินทร์') return { shortForm: 'su', region: 'NORTHEASTERN' };
    else if (value === 22 || value === 'ศรีสะเกษ') return { shortForm: 'si', region: 'NORTHEASTERN' };
    else if (value === 23 || value === 'อุบลราชธานี') return { shortForm: 'ur', region: 'NORTHEASTERN' };
    else if (value === 24 || value === 'ยโสธร') return { shortForm: 'ys', region: 'NORTHEASTERN' };
    else if (value === 25 || value === 'ชัยภูมิ') return { shortForm: 'cy', region: 'NORTHEASTERN' };
    else if (value === 26 || value === 'อำนาจเจริญ') return { shortForm: 'ac', region: 'NORTHEASTERN' };
    else if (value === 27 || value === 'บึงกาฬ') return { shortForm: 'bk', region: 'NORTHEASTERN' };
    else if (value === 28 || value === 'หนองบัวลําภู') return { shortForm: 'nb', region: 'NORTHEASTERN' };
    else if (value === 29 || value === 'ขอนแก่น') return { shortForm: 'kk', region: 'NORTHEASTERN' };
    else if (value === 30 || value === 'อุดรธานี') return { shortForm: 'un', region: 'NORTHEASTERN' };
    else if (value === 31 || value === 'เลย') return { shortForm: 'le', region: 'NORTHEASTERN' };
    else if (value === 32 || value === 'หนองคาย') return { shortForm: 'nk', region: 'NORTHEASTERN' };
    else if (value === 33 || value === 'มหาสารคาม') return { shortForm: 'ms', region: 'NORTHEASTERN' };
    else if (value === 34 || value === 'ร้อยเอ็ด') return { shortForm: 're', region: 'NORTHEASTERN' };
    else if (value === 35 || value === 'กาฬสินธุ์') return { shortForm: 'kl', region: 'NORTHEASTERN' };
    else if (value === 36 || value === 'สกลนคร') return { shortForm: 'sn', region: 'NORTHEASTERN' };
    else if (value === 37 || value === 'นครพนม') return { shortForm: 'nf', region: 'NORTHEASTERN' };
    else if (value === 38 || value === 'มุกดาหาร') return { shortForm: 'md', region: 'NORTHEASTERN' };
    // NORTHERN
    else if (value === 39 || value === 'เชียงใหม่') return { shortForm: 'cm', region: 'NORTHERN' };
    else if (value === 40 || value === 'ลำพูน') return { shortForm: 'ln', region: 'NORTHERN' };
    else if (value === 41 || value === 'ลำปาง') return { shortForm: 'lg', region: 'NORTHERN' };
    else if (value === 42 || value === 'อุตรดิตถ์') return { shortForm: 'ud', region: 'NORTHERN' };
    else if (value === 43 || value === 'แพร่') return { shortForm: 'pr', region: 'NORTHERN' };
    else if (value === 44 || value === 'น่าน') return { shortForm: 'na', region: 'NORTHERN' };
    else if (value === 45 || value === 'พะเยา') return { shortForm: 'py', region: 'NORTHERN' };
    else if (value === 46 || value === 'เชียงราย') return { shortForm: 'cr', region: 'NORTHERN' };
    else if (value === 47 || value === 'แม่ฮ่องสอน') return { shortForm: 'mh', region: 'NORTHERN' };
    // WESTERN
    else if (value === 51 || value === 'ตาก') return { shortForm: 'tk', region: 'WESTERN' };
    else if (value === 56 || value === 'ราชบุรี') return { shortForm: 'rt', region: 'WESTERN' };
    else if (value === 57 || value === 'กาญจนบุรี') return { shortForm: 'kn', region: 'WESTERN' };
    else if (value === 62 || value === 'เพชรบุรี') return { shortForm: 'pe', region: 'WESTERN' };
    else if (value === 63 || value === 'ประจวบคีรีขันธ์') return { shortForm: 'pk', region: 'WESTERN' };
    // CENTRAL
    else if (value === 48 || value === 'นครสวรรค์') return { shortForm: 'ns', region: 'CENTRAL' };
    else if (value === 49 || value === 'อุทัยธานี') return { shortForm: 'ut', region: 'CENTRAL' };
    else if (value === 50 || value === 'กำแพงเพชร') return { shortForm: 'kp', region: 'CENTRAL' };
    else if (value === 52 || value === 'สุโขทัย') return { shortForm: 'so', region: 'CENTRAL' };
    else if (value === 53 || value === 'พิษณุโลก') return { shortForm: 'ps', region: 'CENTRAL' };
    else if (value === 54 || value === 'พิจิตร') return { shortForm: 'pc', region: 'CENTRAL' };
    else if (value === 55 || value === 'เพชรบูรณ์') return { shortForm: 'ph', region: 'CENTRAL' };
    else if (value === 58 || value === 'สุพรรณบุรี') return { shortForm: 'sh', region: 'CENTRAL' };
    else if (value === 59 || value === 'นครปฐม') return { shortForm: 'np', region: 'CENTRAL' };
    else if (value === 60 || value === 'สมุทรสาคร') return { shortForm: 'ss', region: 'CENTRAL' };
    else if (value === 61 || value === 'สมุทรสงคราม') return { shortForm: 'sm', region: 'CENTRAL' };
    // SOUNTHERN
    else if (value === 64 || value === 'นครศรีธรรมราช') return { shortForm: 'nt', region: 'SOUTHERN' };
    else if (value === 65 || value === 'กระบี่') return { shortForm: 'kr', region: 'SOUTHERN' };
    else if (value === 66 || value === 'พังงา') return { shortForm: 'pg', region: 'SOUTHERN' };
    else if (value === 67 || value === 'ภูเก็ต') return { shortForm: 'pu', region: 'SOUTHERN' };
    else if (value === 68 || value === 'สุราษฎร์ธานี') return { shortForm: 'st', region: 'SOUTHERN' };
    else if (value === 69 || value === 'ระนอง') return { shortForm: 'rn', region: 'SOUTHERN' };
    else if (value === 70 || value === 'ชุมพร') return { shortForm: 'cp', region: 'SOUTHERN' };
    else if (value === 71 || value === 'สงขลา') return { shortForm: 'sg', region: 'SOUTHERN' };
    else if (value === 72 || value === 'สตูล') return { shortForm: 'sa', region: 'SOUTHERN' };
    else if (value === 73 || value === 'ตรัง') return { shortForm: 'tg', region: 'SOUTHERN' };
    else if (value === 74 || value === 'พัทลุง') return { shortForm: 'pl', region: 'SOUTHERN' };
    else if (value === 75 || value === 'ปัตตานี') return { shortForm: 'pi', region: 'SOUTHERN' };
    else if (value === 76 || value === 'ยะลา') return { shortForm: 'yl', region: 'SOUTHERN' };
    else if (value === 77 || value === 'นราธิวาส') return { shortForm: 'nw', region: 'SOUTHERN' };
    // ??
    return { shortForm: value, region: 'UNKNOWN' };
  };

  return {
    highChartThailandMap,
    getProperty,
  };
};
